import { $get } from '@js/request'
import { TuiFeiSchema } from '@src/components/Schema/TuiFeiSchema'

// 获取列表
export async function getListRequest (caseid: string): Promise<TuiFeiSchema[]> {
  const res = await $get('/api/xd/item/caseTuifeiIndex', { caseid })
  return res.data
}
